import Logo from "../images/fmsx.png";
import { IoMdCall } from "react-icons/io";

import { BiLogoFacebook, BiLogoLinkedin } from "react-icons/bi";
import {
  AiFillInstagram,
  AiFillYoutube,
  AiOutlineMail,
} from "react-icons/ai";
import { IoLogoWhatsapp } from "react-icons/io";
import { IoLocationOutline } from "react-icons/io5";

import {
  address,
  email,
  fidelitus_gallery_website_url,
  hrlabs_website_url,
  mobile,
  project_website_url,
  transaction_website_url,
} from "../constant/Appconstants";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigator = useNavigate();

  const social_media = [
    { icon: BiLogoFacebook, name: "Facebook", id: 1, path: "https://www.facebook.com/Fidelitus/" },
    { icon: AiFillInstagram, name: "Instagram", id: 2, path: "https://www.instagram.com/fidelitus.corp/" },
    { icon: BiLogoLinkedin, name: "LinkedIn", id: 3, path: "https://in.linkedin.com/company/fidelituscorp-property-services-private-ltd" },
    { icon: AiFillYoutube, name: "YouTube", id: 4, path: "https://youtu.be/y-3CAl8M9yA" },
    { icon: IoLogoWhatsapp, name: "WhatsApp", id: 5, path: "https://api.whatsapp.com/send?phone=919845062227&text=Hi%20I%20would%20like%20to%20connect%20with%20you" },
  ];

  const menu = [
    { name: "Home", path: "/home", id: 1 },
    { name: "About FMS", path: "/about", id: 2 },
    { name: "Why us", path: "/why-us", id: 7 },
    { name: "Our Services", path: "/services", id: 3 },
    { name: "Contact Us", path: "/contact", id: 4 },
    { name: "Careers", path: "/join_us", id: 6 },
  ];

  const other_services = [
    { id: 1, name: "Real Estate Transaction", path: transaction_website_url, new: true },
    { id: 2, name: "Projects", path: project_website_url, new: true },
    { id: 3, name: "HR Labs", path: hrlabs_website_url, new: true },
    { id: 4, name: "Fidelitus Gallery", path: fidelitus_gallery_website_url, new: true },
  ];

  async function openPage1(v) {
    window.open(v?.path, "_blank");
  }

  return (
    <>
      <footer className="relative w-full overflow-hidden bg-gradient-to-br from-[#f4fbfd] via-white to-[#eef8fb] border-t border-[#027d9b]/10">
        <div className="absolute top-[-100px] right-[-100px] w-[280px] h-[280px] bg-[#027d9b]/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-[-120px] left-[-100px] w-[300px] h-[300px] bg-[#e58c3d]/10 rounded-full blur-3xl"></div>

        <div className="relative grid w-[88vw] gap-10 py-14 mx-auto md:grid-cols-5">
          <div className="md:col-span-2">
            <div className="inline-flex items-center justify-center p-3 bg-white border border-[#027d9b]/10 rounded-2xl shadow-sm">
              <img
                src={Logo}
                alt="Fidelitus FMS"
                className="w-[150px] h-[42px] object-contain cursor-pointer"
              />
            </div>

            <h6 className="mt-4 text-[16px] 2xl:text-[19px] font_thicker text-slate-900">
              Fidelitus FMS Services
            </h6>

            <h6 className="mt-1 text-[12px] 2xl:text-[14px] font_normal text-gray-600">
              Powered By{" "}
              <span className="text-[#e58c3d] font_thicker">Fidelitus</span>
            </h6>

            <div className="mt-6">
              <h6 className="text-[13px] font_thicker uppercase text-[#027d9b]">
                Head Office
              </h6>

              <div className="flex gap-3 mt-3">
                <IoLocationOutline color="#027d9b" size={24} />
                <h6 className="text-[12px] 2xl:text-[14px] font_normal text-gray-600 leading-relaxed">
                  {address}
                </h6>
              </div>

              <div className="flex items-center gap-3 mt-3">
                <IoMdCall color="#027d9b" size={18} />
                <h6 className="text-[12px] 2xl:text-[14px] font_normal text-gray-600">
                  {mobile}
                </h6>
              </div>

              <div className="flex items-center gap-3 mt-3">
                <AiOutlineMail color="#027d9b" size={18} />
                <h6 className="text-[12px] 2xl:text-[14px] font_normal text-gray-600">
                  {email}
                </h6>
              </div>
            </div>
          </div>

          <div>
            <h6 className="uppercase text-[13px] font_thicker text-slate-900 mb-4">
              Quick Links
            </h6>

            {menu?.map((m) => (
              <h6
                onClick={() => navigator(m?.path)}
                key={m?.path}
                className="group w-fit font_normal text-[13px] 2xl:text-[15px] py-1.5 text-gray-600 hover:text-[#027d9b] cursor-pointer transition-all duration-300"
              >
                <span className="inline-block transition-all duration-300 group-hover:translate-x-1">
                  {m?.name}
                </span>
              </h6>
            ))}
          </div>

          <div>
            <h6 className="uppercase text-[13px] font_thicker text-slate-900 mb-4">
              Other Business
            </h6>

            <h6 className="text-[12px] 2xl:text-[14px] font_normal text-gray-600 mb-3 leading-relaxed">
              Apart from FMS Services, we also provide solutions across more domains.
            </h6>

            {other_services?.map((s, i) => (
              <h6
                key={i}
                onClick={() => openPage1(s)}
                className="group w-fit text-[13px] 2xl:text-[15px] font_normal py-1.5 text-gray-600 hover:text-[#027d9b] cursor-pointer transition-all duration-300"
              >
                <span className="text-[#e58c3d] mr-1">•</span>
                <span className="inline-block transition-all duration-300 group-hover:translate-x-1">
                  {s?.name}
                </span>
              </h6>
            ))}
          </div>

          <div>
            <h6 className="uppercase text-[13px] font_thicker text-slate-900 mb-4">
              Follow Us
            </h6>

            <div className="flex flex-wrap gap-3">
              {social_media?.map((s, i) => {
                const Icon = s.icon;
                return (
                  <a
                    key={i}
                    href={s?.path}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={s?.name}
                    className="grid w-10 h-10 place-items-center rounded-full bg-white border border-[#027d9b]/10 text-[#027d9b] shadow-sm transition-all duration-300 hover:bg-[#027d9b] hover:text-white hover:-translate-y-1 hover:shadow-md"
                  >
                    <Icon size={20} />
                  </a>
                );
              })}
            </div>

            <button
              onClick={() => navigator("/contact")}
              className="mt-7 px-6 py-3 rounded-full bg-[#027d9b] text-white text-[13px] 2xl:text-[15px] font_thicker transition-all duration-300 hover:bg-[#026b84] hover:scale-105 shadow-lg shadow-[#027d9b]/20"
            >
              Get In Touch
            </button>
          </div>
        </div>
      </footer>

      <p className="w-full py-3 text-center text-[10px] 2xl:text-[12px] font_normal text-gray-500 bg-white border-t border-gray-100">
        © 2024 Fidelitus FMS SERVICES. All Rights Reserved
      </p>
    </>
  );
}










/////+++ __ >Old one


// import Logo from '../images/fmsx.png'
// import {IoMdCall} from 'react-icons/io'

// import {BiLogoFacebook,BiLogoLinkedin} from 'react-icons/bi'
// import {AiFillInstagram,AiFillYoutube,AiOutlineMail} from 'react-icons/ai'
// import {IoLogoWhatsapp} from 'react-icons/io'
// import {IoLocationOutline} from 'react-icons/io5'

// import { address, email, fidelitus_gallery_website_url, hrlabs_website_url, mobile, project_website_url, transaction_website_url } from '../constant/Appconstants'
// import { useNavigate } from 'react-router-dom'


// export default function Footer() {

//   const navigator = useNavigate()



//   const social_media = [
//     {'icon':BiLogoFacebook,name:'Facebook',id:1,path:'https://www.facebook.com/Fidelitus/'},
//     {'icon':AiFillInstagram,name:'Instagram',id:2,path:'https://www.instagram.com/fidelitus.corp/'},
//     {'icon':BiLogoLinkedin,name:'LinkedIn',id:3,path:'https://in.linkedin.com/company/fidelituscorp-property-services-private-ltd'},
//     {'icon':AiFillYoutube,name:'YouTube',id:4,path:'https://youtu.be/y-3CAl8M9yA'},
//     {'icon':IoLogoWhatsapp,name:'WhatsApp',id:5,path:'https://api.whatsapp.com/send?phone=919845062227&text=Hi%20I%20would%20like%20to%20connect%20with%20you'},
//   ]

//   const menu = [
//     {name:'Home',path:'/home',id:1},
//     {name:'About FMS',path:'/about',id:2},
//     {name:'Why us',path:'/why-us',id:7},
//     {name:'Our Services',path:'/services',id:3},
//     {name:'Contact Us',path:'/contact',id:4},
//     {name:'Careers',path:'/join_us',id:6},
//   ]




//   const other_services = [
//     {
//       id:1,
//       name:'Real Estate Transaction',
//       path:transaction_website_url,
//       // path:'/whats-more/real-estate-transaction',
//       new:true
//   },
//   {
//     id:2,
//     name:'Projects',
//     path:project_website_url,
//     // path:'/whats-more/projects',
//     new:true
// },
//   {
//       id:3,
//       name:'HR Labs',
//       path:hrlabs_website_url,
//       // path:'/whats-more/hr-labs',
//       new:true
//   },
 
//   {
//       id:4,
//       name:'Fidelitus Gallery',
//       path:fidelitus_gallery_website_url,
//       // path:'/whats-more/fidelitus-gallery',
//       new:true
//   },
//   ]

//   async function openPage1(v){
//     window.open(v?.path,'_blank')
//   }

//   return (
//     <>
//     <div className="min-w-screen bg-[#2b2c2d]  py-10  border-slate-100 w-full text-[#fff]">
//        <div className='grid w-[85vw]  mx-auto   md:grid-cols-5'>

//         <div className='pr-4 border-gray-600 md:border-r'>
//         <img src={Logo} alt="FidelitusHrLab" className='w-[140px] bg-white h-[40px]  md:ml-0 object-stretch cursor-pointer' />

//         <h6 className='text-[12px] font_thicker mt-2'>Fidelitus FMS Services</h6>
//         <h6 className='text-[11px] font_normal font-[500]'>Powered By  <span className='text-[#e58c3d] font_thicker font-[800]'>Fidelitus</span> </h6>


//         <div>
//            <h6 className='text-[14px] font-[600] font_thicker text-white-500 mt-4'>HEAD OFFICE</h6>
//            <div className='flex mt-2 -ml-7'>
//             <IoLocationOutline color='#4190ac' size={50} />
//             <h6 className='text-[11px] cursor-pointer font_normal pl-3'>{address}</h6>
//            </div>

//            <div className='flex mt-2 -ml-7'>
//            <IoMdCall color='#4190ac' size={15} />
//             <h6 className='text-[11px]  cursor-pointer font_normal pl-2'>{mobile}</h6>
//             </div>

//             <div className='flex -ml-7 mt-2.5'>
//            <AiOutlineMail color='#4190ac' size={15}/>
//             <h6 className='ml-1 text-[11px]  cursor-pointer font_normal pl-2'>{email}</h6>
//             </div>
//         </div>

//         </div>

//         <div className='mt-4 border-gray-600 md:border-r md:mt-0 md:px-4'> 
//             <h6 className='uppercase text-[13px] font_thicker text-white font-[600] mb-2'>Quick Links</h6>
//                 {menu?.map((m)=>(
//                   <h6 onClick={()=>navigator(m?.path)} key={m?.path} className='font_normal text-[12px] py-1 text-white opacity-70 hover:opacity-100  cursor-pointer'>{m?.name}</h6>
//                 ))}
//                 {/* <h6 className='text-[12px] py-1 text-white  mt-2'>Download Our Fidelitus IFMS Profile by clicking  <Link href={'https://fidecrmfiles.s3.amazonaws.com/FMS+PROFILE+29-7-2022.pdf'} target='_blank'><span className='text-[#e58c3d] font-[800] cursor-pointer hover:underline'> Download</span></Link>  Link.</h6> */}

//         </div>

//         <div className='mt-4 border-gray-600 md:border-r md:mt-0 md:px-4'> 
//             <h6 className='uppercase text-[13px] font_thicker text-white font-[600]'>Other Business</h6>
//             <h6 className='text-[11px] font-[300] font_normal text-white my-2 leading-tight'>Rather than FMS Services We also provides services on more domain..</h6>
//            {other_services?.map((s,i)=>(
//             <h6 key={i} onClick={()=>openPage1(s)} className='text-[12px] font_normal py-1 text-white opacity-70 hover:opacity-100 cursor-pointer'> * {s?.name}</h6>
//            ))}

//         </div>

//         <div className='mt-4 border-gray-600 md:mt-0 md:px-4 md:border-r'> 
//             <h6 className='uppercase font_normal text-[13px] text-white font-[600] mb-1.5'>Follow Us</h6>
//             {social_media?.map((s,i)=>(
//             <a key={i} href={s?.path} target='_blank'>
//             <h6  className='text-[12px] font_normal py-1 text-white opacity-70 hover:opacity-100 cursor-pointer'>{s?.name}</h6>
//             </a>   
//            ))}
//         </div>


//         <div className='mt-4 border-gray-200 md:mt-0 md:px-4'> 
//             <h6 className='uppercase text-[13px] font_thicker text-white font-[600]'>MORE LINKS</h6>
//             {/* <h6 className='text-[11px] font-[300] font_normal text-white my-2 leading-tight'>If your&apos;e found of art and craft please visit our gallery..</h6>

//            <a href={'https://fidelitusgallery.com/'} target='_blank'>
//             <h6 className='text-[12px] py-1 text-white font_normal opacity-70 cursor-pointer hover:opacity-100'>{'Fidelitus Gallery'}</h6>
//             </a> */}
//             <h6 className='text-[11px] font-[300] font_normal text-white my-2 leading-tight'>If your&apos;e intrested in bring light to the upcoming future then donate for shilpa foundation wher each rupee used for student and oldage welfare..</h6>
            
//             <a href={'https://shilpafoundation.org/'} target='_blank'>
//             <h6 className='text-[12px] py-1 opacity-70  font_normalcursor-pointer hover:opacity-100'>{'Shilpa Foundation'}</h6>
//             </a>

//         </div>



//        </div>
//     </div>
//     <p className='text-[9px] bg-[#282829] text-white text-center w-full font_normal py-2 text-slate-400'>© 2024 Fidelitus FMS SERVICES. All Rights Reserved</p>
//     </>
//   )
// }
